import { banDurationToString, cn } from "@/lib/utils";
import { AdminJailDurationType } from "@shared/otherTypes";
import { Settings2Icon, XIcon } from "lucide-react";
import { HoverTip } from '@/components/ui/tooltip';
import type { templateFlags } from "./templateFlags";


type BanTemplatesListItemProps = {
    id: string;
    reason: string;
    duration?: AdminJailDurationType; //warn templates have none
    flag?: typeof templateFlags[keyof typeof templateFlags];
    onEdit: (id: string) => void;
    onRemove: (id: string) => void;
    disabled: boolean;
}

export default function BanTemplatesListItem({ id, reason, duration, flag, onEdit, onRemove, disabled }: BanTemplatesListItemProps) {
    return (<>
        <div className="grow sm:flex items-center justify-items-start gap-2">
            {duration ? (
                <div className={cn(
"bg-black/40 px-2 py-0.5 my-1 sm:my-0 border text-sm rounded w-max shrink-0 uppercase select-none",
                    duration === 'permanent'
                        ? 'border-destructive bg-destructive-hint text-destructive'
                        : 'border-primary text-primary opacity-85'
                )}>
                    {banDurationToString(duration)}
                </div>
            ) : null}
            {flag ? (
                <HoverTip label={flag.badgeLabel}>
                    <div
                        className={cn(
"flex items-center gap-1 w-max shrink-0 my-1 sm:my-0 px-2 py-0.5 border text-sm rounded uppercase select-none",
                            flag.badgeClass,
                        )}
                        aria-label={flag.badgeLabel}
                    >
                        {flag.badgeIcon} {flag.badge}
                    </div>
                </HoverTip>
            ) : null}
            <span className="line-clamp-5 md:line-clamp-3">
                {reason}
            </span>
        </div>
        <div className="flex gap-2">
            <button
                className={cn(
"text-muted-foreground",
                    disabled ? "opacity-50 cursor-not-allowed" : "hover:text-primary hover:scale-110"
                )}
                onClick={() => onEdit(id)}
                disabled={disabled}
            >
                <Settings2Icon className="size-6" />
            </button>
            <button
                className={cn(
"text-muted-foreground",
                    disabled ? "opacity-50 cursor-not-allowed" : "hover:text-destructive hover:scale-110"
                )}
                onClick={() => onRemove(id)}
                disabled={disabled}
            >
                <XIcon className="size-6" />
            </button>
        </div>
    </>)
}
